import styled, { css } from 'styled-components';

export const TableHeaderSorterSC = styled.th`
  position: relative;
  font-weight: normal;
  text-align: center;
  padding-bottom: 8px;
  padding-top: 6px;

  &:before {
    z-index: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    content: '';
    width: 100%;
    height: 100%;
    border: 2px solid white;
    border-right: none;
    border-left: none;
  }

  &:first-child {
    text-align: left;
    padding-left: 32px;

    &:before {
      border-top-left-radius: 20px;
      border-left: 2px solid white;
    }
  }
  &:last-child {
    padding-right: 32px;
    &:before {
      border-top-right-radius: 20px;
      border-right: 2px solid white;
    }
  }

  ${({ sortKey }) =>
    sortKey !== undefined
      ? css`
          cursor: pointer;
          padding-left: 22px;
        `
      : ''};
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const SortSC = styled.div`
  display: inline-block;
  width: 8px;
  margin: 0 8px;
  position: relative;

  svg {
    position: relative;
    display: block;

    &:first-child {
      transform: rotate(180deg);
      margin-bottom: 2px;
    }
    &:last-child {
    }
  }
`;
